module.exports = __webpack_public_path__ + "static/media/bank.9105dc9e.svg";